// test786
(786 && 0);
